export const consent = 'I Provide Consent To Process The Shared Information.'

export const quarters = [{ value: 'Q1', label: 'Q1' }, { value: 'Q2', label: 'Q2' }, { value: 'Q3', label: 'Q3' }, { value: 'Q4', label: 'Q4' }]

export const matchTypes = {
    MATCH: {
        label: 'MATCH',
        color: 'green',
    },
    NO_MATCH: {
        label: 'NO MATCH',
        color: 'red',
    },
    INDETERMINATE: {
        label: 'INDETERMINATE',
        color: 'grey',
    },
}

export const fieldLabels = {
    name_match_status: 'Name',
    dob_match_status: 'Date Of Birth',
}